import { ChangeEvent, useState } from 'react';
import { InputProps } from '@/shared/ui/core';
import { EyeIcon, EyeSlashIcon, XCircleIcon } from '@phosphor-icons/react/ssr';


type UsePasswordInputProps = {
    defaultValue?: InputProps['defaultValue'];
    value?: InputProps['value'];
    onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onClear?: () => void;
}


export const usePasswordInput = ({
    defaultValue = '',
    value   : externalValue,
    onChange: externalOnChange,
    onClear: onClearProp
}: UsePasswordInputProps) => {
    const isControlled                = externalValue !== undefined;
    const [ internalValue, setValue ] = useState(defaultValue);
    const [ inputType, setInputType ] = useState<'password' | 'text'>('password');

    const isPasswordType = inputType === 'password';
    const Icon           = isPasswordType ? EyeIcon : EyeSlashIcon;
    const value          = isControlled ? externalValue : internalValue;

    const onChangeType = () => {
        setInputType(isPasswordType ? 'text' : 'password');
    };

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (!isControlled) setValue(event.target.value);
        externalOnChange?.(event);
    };

    const onClear = () => {
        if (onClearProp) {
            onClearProp();
        } else {
            onChange({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
        }
    };

    return {
        ClearIcon: XCircleIcon,
        Icon,
        inputType,
        onChange,
        onChangeType,
        onClear,
        value,
    };
};
